import cn from "classnames";
import Tooltip from "rc-tooltip";
import React, { Fragment } from "react";

const OnlineStatus = (props) => {
    const { lastSignInAt, isOnline, short } = props;
    const cname = (extra) =>
        cn("driver-status__wrap", {
            "d-inline-block pr-1": short,
            [extra]: !!extra,
        });
    if (lastSignInAt) {
        if (isOnline) {
            return (
                <div className={cname("text-success")}>
                    {short ? (
                        <Tooltip overlay="Онлайн">
                            <i className="icon-uEA70-circle driver-status__icon" />
                        </Tooltip>
                    ) : (
                        <Fragment>
                            <i className="icon-uEA70-circle driver-status__icon" />
                            &nbsp;Онлайн
                        </Fragment>
                    )}
                </div>
            );
        } else {
            const { organizationTimezone } = props;
            if (!organizationTimezone.id) {
                return null;
            }
            const localeLastSignInAt = new Date(lastSignInAt).toLocaleString("ru-RU", {
                timeZone: organizationTimezone.id,
            });
            return (
                <div className={cname()}>
                    {short ? (
                        <Tooltip overlay={`Был онлайн: ${localeLastSignInAt} ${organizationTimezone.displayName}`}>
                            <i className="icon-uEA70-circle driver-status__icon" />
                        </Tooltip>
                    ) : (
                        <Fragment>
                            <i className="icon-uEA70-circle driver-status__icon" />
                            &nbsp;
                            <span className="driver-status__text">
                                Был онлайн:&nbsp;
                                {localeLastSignInAt} {organizationTimezone.displayName}
                            </span>
                        </Fragment>
                    )}
                </div>
            );
        }
    } else {
        return (
            <div className={cname("text-danger")}>
                {short ? (
                    <Tooltip overlay="Моб. приложение не установлено">
                        <i className="icon-uEA70-circle driver-status__icon" />
                    </Tooltip>
                ) : (
                    <Fragment>
                        <i className="icon-uEA70-circle driver-status__icon" />
                        &nbsp;
                        <span className="driver-status__text">Моб. приложение не установлено</span>
                    </Fragment>
                )}
            </div>
        );
    }
};

export default OnlineStatus;
